
import request from '@/utils/request'

export default {
  getTopSearchKeywordList(data) {
    return request({
      url: '/searchkey/getTopSearchKeywordList',
      method: 'post',
      data
    })
  },
  saveSearchKeyword(data){
    return request({
      url: '/searchkey/saveSearchKeyword',
      method: 'post',
      data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/searchkey.js